var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"value":_vm.avance,"size":"45","width":"7","color":_vm.setColor()}},[_vm._v(" "+_vm._s(_vm.avance)+"% ")])}
var staticRenderFns = []

export { render, staticRenderFns }